import { render } from "./LoginAuditTrail.vue?vue&type=template&id=81b0af4c&ts=true"
import script from "./LoginAuditTrail.vue?vue&type=script&lang=ts"
export * from "./LoginAuditTrail.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__